import { Edit } from 'react-admin';
import { OrderDetailForm } from './OrderDetail.Form';

export const OrderDetailEdit = () => {
    return (
        <Edit>
            <OrderDetailForm />
        </Edit>
    );
};
